import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import '../styles/Donate.css'; // Optional styling

const Donate = ({ walletAddress }) => {
    const [amount, setAmount] = useState('');
    const [region, setRegion] = useState('');
    const [type, setType] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [copied, setCopied] = useState(false);

    const usdtAddress = walletAddress?.usdt?.stock || 'Unavailable';

    const handleSubmit = (e) => {
        e.preventDefault();
        if (amount && region && type && usdtAddress !== 'Unavailable') {
            setSubmitted(true);
        }
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(usdtAddress)
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 3000);
            })
            .catch(err => console.error('Copy failed:', err));
    };

    if (submitted) {
        return (
            <div className="donation-summary">
                <div className="wallet-sections">
                    <h3>
                        Please send <strong>${amount}</strong> of <strong>USDT (ERC20)</strong>
                        for <strong>{type}</strong> (Region: <strong>{region}</strong>)
                        to the wallet address below.
                    </h3>

                    <div className="qr-code-containers">
                        <QRCodeSVG
                            value={usdtAddress}
                            size={200}
                            level="H"
                        />
                    </div>

                    <div className="wallet-address-container">
                        <span className="wallet-address">{usdtAddress}</span>
                        <button className="copy-btn" onClick={handleCopy}>
                            <FontAwesomeIcon icon={faCopy} />
                        </button>
                    </div>

                    {copied && <div className="copied-notification">Wallet address copied!</div>}
                </div>
            </div>
        );
    }

    return (
        <div className="donate-form-container">
            <h2>Make a Donation</h2>
            <form onSubmit={handleSubmit} className="donation-form">
                <label>Donation Amount (USD):</label>
                <input
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="e.g. 50"
                    required
                    className='input-field'
                />

                <label>Select Continent / Region:</label>
                <select value={region} onChange={(e) => setRegion(e.target.value)} required>
                    <option value="" disabled>Select region</option>
                    <option value="North Africa">North Africa</option>
                    <option value="West Africa">West Africa</option>
                    <option value="Southern Africa">Southern Africa</option>
                    <option value="East Africa">East Africa</option>
                    <option value="Central Africa">Central Africa</option>

                    <option value="North America">North America</option>
                    <option value="South America">South America</option>

                    <option value="Northern Europe">Northern Europe</option>
                    <option value="Southern Europe">Southern Europe</option>
                    <option value="Eastern Europe">Eastern Europe</option>
                    <option value="Western Europe">Western Europe</option>

                    <option value="North Asia">North Asia</option>
                    <option value="South Asia">South Asia</option>
                    <option value="Southeast Asia">Southeast Asia</option>
                    <option value="Central Asia">Central Asia</option>

                    <option value="Australia & Oceania">Australia & Oceania</option>
                    <option value="Middle East">Middle East</option>
                    <option value="Other">Other</option>
                </select>

                <label>Donation Type:</label>
                <select value={type} onChange={(e) => setType(e.target.value)} required>
                    <option value="" disabled>Select purpose</option>
                    <option value="Family Support">Family Support</option>
                    <option value="School Fees">School Fees</option>
                    <option value="Medical">Medical</option>
                    <option value="Food Aid">Food Aid</option>
                    <option value="Community Project">Community Project</option>
                    <option value="Emergency Relief">Emergency Relief</option>
                </select>

                <button type="submit" className="submit-btn">Proceed to Donate</button>
            </form>
        </div>
    );
};

export default Donate;
